import React from "react";
import mapServiceItem from "./mapServiceItem";

function EquipmentIcon({ title }) {
    const commonProps = {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: 1.9,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        "aria-hidden": true,
    };

    switch (title) {
        case "Cámaras 4K":
            return (
                <svg {...commonProps}>
                    <rect x="3.5" y="7" width="11.5" height="10" rx="2" />
                    <path d="m15 10 5.5-3v10L15 14" />
                    <circle cx="9.25" cy="12" r="2.1" />
                </svg>
            );
        case "Iluminación LED":
            return (
                <svg {...commonProps}>
                    <path d="M12 3.5a5.1 5.1 0 0 1 5.1 5.1c0 2-1 3.3-2.1 4.4-.8.8-1.2 1.5-1.3 2.5h-3.4c-.1-1-.5-1.7-1.3-2.5-1.1-1.1-2.1-2.4-2.1-4.4A5.1 5.1 0 0 1 12 3.5Z" />
                    <path d="M9.5 18h5" />
                    <path d="M10 20.5h4" />
                </svg>
            );
        case "Audio broadcast":
            return (
                <svg {...commonProps}>
                    <path d="M12 14.5a3 3 0 0 0 3-3v-4a3 3 0 0 0-6 0v4a3 3 0 0 0 3 3Z" />
                    <path d="M6.5 11.5a5.5 5.5 0 0 0 11 0" />
                    <path d="M12 17v3.5" />
                    <path d="M9 20.5h6" />
                </svg>
            );
        case "Switcher ATEM":
            return (
                <svg {...commonProps}>
                    <rect x="3.5" y="7" width="17" height="10" rx="2.2" />
                    <path d="M8 11.5h2" />
                    <path d="M8 14.5h2" />
                    <circle cx="14" cy="12" r="1.5" />
                    <circle cx="18" cy="12" r="1.5" />
                </svg>
            );
        case "Sala de edición":
            return (
                <svg {...commonProps}>
                    <rect x="3.5" y="5" width="17" height="11.5" rx="2" />
                    <path d="M9 19h6" />
                    <path d="M12 16.5V19" />
                    <path d="m9.2 9.4 5.2 2.6-5.2 2.6Z" />
                </svg>
            );
        case "Estudio FISP TV":
            return (
                <svg {...commonProps}>
                    <rect x="4.5" y="6" width="15" height="10.5" rx="2.2" />
                    <path d="M10 18.5h4" />
                    <path d="M12 16.5v2" />
                    <path d="m9.2 3.8 2.8 2.5 2.8-2.5" />
                </svg>
            );
        case "Drones":
            return (
                <svg {...commonProps}>
                    <circle cx="12" cy="12" r="2.2" />
                    <circle cx="6.5" cy="7" r="2" />
                    <circle cx="17.5" cy="7" r="2" />
                    <circle cx="6.5" cy="17" r="2" />
                    <circle cx="17.5" cy="17" r="2" />
                    <path d="M10.3 10.3 7.9 8.4" />
                    <path d="M13.7 10.3 16.1 8.4" />
                    <path d="M10.3 13.7 7.9 15.6" />
                    <path d="M13.7 13.7 16.1 15.6" />
                </svg>
            );
        case "Streaming rig":
            return (
                <svg {...commonProps}>
                    <circle cx="12" cy="12" r="1.4" />
                    <path d="M8.4 8.4a5 5 0 0 0 0 7.2" />
                    <path d="M15.6 8.4a5 5 0 0 1 0 7.2" />
                    <path d="M5.8 5.8a8.6 8.6 0 0 0 0 12.4" />
                    <path d="M18.2 5.8a8.6 8.6 0 0 1 0 12.4" />
                </svg>
            );
        case "Motion graphics":
            return (
                <svg {...commonProps}>
                    <path d="M4.5 6.5h15" />
                    <path d="M7.5 6.5v11" />
                    <path d="M15 10.5 19.5 6v11L15 12.5" />
                    <path d="M10.5 17.5h4" />
                </svg>
            );
        default:
            return <span aria-hidden="true">{title?.charAt(0)}</span>;
    }
}

export default function ProductionEquipment({ items }) {
    return (
        <div className="production-equipment">
            {items.map((item) => {
                const card = mapServiceItem(item);

                return (
                    <article className="production-equipment-card" key={card.title}>
                        <span className="production-equipment-icon">
                            <EquipmentIcon title={card.title} />
                        </span>
                        <div>
                            <h3>{card.title}</h3>
                            <p>{card.text}</p>
                        </div>
                    </article>
                );
            })}
        </div>
    );
}
